import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { RouteChildrenProps } from "react-router";
import { ROUTE_PATHS } from "../../../constants/url-config";
import i18n from "../../../utils/i18n";
import { ResearchIcon, SettingIcon } from "../../atoms/icon";
import AppMainCard, { MainCardProp } from "../../atoms/main-card";

const ITEMS: MainCardProp[] = [
    {
        index: 1,
        name: i18n.t("BBERM.scenarioAssetPlanning"),
        icon: <ResearchIcon />,
        link: ROUTE_PATHS.ScenarioFrontierScenarioAndBudgeting
    }, 
    {
        index: 2,
        name: i18n.t("BBERM.creditConcentrationStressTesting"),
        icon: <ResearchIcon />,
        link: ROUTE_PATHS.BBERM_StressTesting,
    }, 
    {
        index: 3,
        name: i18n.t("BBERM.creditScoringModels"),
        icon: <ResearchIcon />,
        link: ROUTE_PATHS.CreditScoring,
    }, 
    {
        index: 4,
        name: i18n.t("BBERM.kriKciRepository"),
        icon: <ResearchIcon />,
        link: ROUTE_PATHS.BBERM_KRI_KCI_Repo,
    },
    {
        index: 5,
        name: i18n.t("BBERM.strategicIfrs"),
        icon: <ResearchIcon />,
        link: ROUTE_PATHS.StrategicIFRS,
    },
    {
        index: 6,
        name: i18n.t("BBERM.resilienceDashboard"),
        icon: <ResearchIcon />,
        link: ROUTE_PATHS.ERMModule
    },
    {
        index: 7,
        name: i18n.t("BBERM.economicCapital"),
        icon: <ResearchIcon />,
        link: ROUTE_PATHS.ECAPModule,
    }, 
    {
        index: 8,
        name: i18n.t("BBERM.loanBookLifetimeIncomeAnalysis"),
        icon: <ResearchIcon />,
        link: ROUTE_PATHS.PortfolioRAROCModule,
    }, 

]

interface Props extends RouteChildrenProps { }

const ScenarioFrontier = (props: Props) => {

    const { t } = useTranslation();

    return (
        <div className="ecap-leader-wrapper">
            <AppMainCard items={ITEMS}/>
        </div>
    )
}

export default ScenarioFrontier